import type { ApiWallpaperSettings } from '../api/types';

export function getWallpaperSettingsSignature(settings?: ApiWallpaperSettings): string {
  if (!settings) {
    return '';
  }

  return [
    settings.backgroundColors?.join(',') || '',
    settings.intensity ?? '',
    settings.rotation ?? '',
    settings.isBlurred ? '1' : '0',
    settings.isMotion ? '1' : '0',
    settings.emoticon || '',
  ].join('|');
}
